'use client';

import { useEffect, useState } from 'react';
import { useHandleError } from '@/hooks/useHandleError';
import { apiFetch } from '@/lib/api/apiClient';
import { Announcement } from '@/types/announcemants';
import ServiceHeader from '@/components/layout/service/ServiceHeader';
import AnnouncementListUnit from '@/(routers)/announcements/list/components/unit/AnnouncementListUnit';

export default function AnnouncementList() {
    const { handleError } = useHandleError();
    const [announcementData, setAnnouncementData] = useState<Announcement[] | null>(null);

    useEffect(() => {
        (async () => {
            try {
                const data = await apiFetch(`/announcements`);
                setAnnouncementData(data);
            } catch (error: unknown) {
                handleError(error);
            }
        })();
    }, []);

    return (
        <>
            <ServiceHeader title="Announcement." />
            <div className="flex justify-center w-full mt-5 pb-12">
                <div className="flex w-full md:w-[98%] justify-center items-start">
                    {announcementData && announcementData.length > 0 && (
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-8 md:gap-4">
                            {announcementData.map((data) => (
                                <AnnouncementListUnit key={data.id} data={data} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
